import { classNames } from "../styles/classNames";

interface ProgressBarProps {
  value: number;
  className?: string;
  barClassName?: string;
}

function clampPercent(value: number): number {
  if (Number.isNaN(value)) {
    return 0;
  }
  if (value < 0) {
    return 0;
  }
  if (value > 100) {
    return 100;
  }
  return value;
}

export default function ProgressBar({ value, className, barClassName }: ProgressBarProps) {
  const percent = clampPercent(value);
  return (
    <div className={classNames("app-progress-track", className)} role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(percent)}>
      <div className={classNames("app-progress-bar", barClassName)} style={{ width: `${percent}%` }} />
    </div>
  );
}
